window.anvil.component('modal', (el, data) => {
    const {id} = data;

    // Bail early if no ID is provided.
    if (!id) {
        console.error('No ID provided for modal component.');
        return;
    }

    /**
     * Open the modal.
     */
    function open() {
        el.classList.add('is-active');

        // Maybe play a video.
        const video = el.querySelector('video');

        if (video) {
            video.play();
        }

        // Maybe enable an iframe.
        const iframe = el.querySelector('iframe');

        if (iframe) {
            iframe.src = iframe.dataset.src;
        }
    }

    /**
     * Close the modal.
     */
    function close() {
        el.classList.remove('is-active');

        // Maybe pause a video.
        const video = el.querySelector('video');

        if (video) {
            video.pause();
        }

        // Maybe disable an iframe.
        const iframe = el.querySelector('iframe');

        if (iframe) {
            iframe.src = '';
        }
    }

    // Detect triggers.
    document.body.addEventListener('click', ({target}) => {
        const trigger = target.closest(`.js-modal-trigger[data-modal="${id}"]`);
        if (!trigger) return;

        // Show modal.
        open();
    });

    // Bind close button.
    el.addEventListener('click', ({target}) => {
        const closeBtn = target.closest('.js-modal-close');
        if (!closeBtn) return;

        close();
    });
});
